import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Mail, ChevronDown } from "lucide-react";
import FadeInUp from "./FadeInUp";
import { faqs } from "./landingData";

const LandingFAQ = () => {
  const { i18n } = useTranslation();
  const t = (obj) => obj[i18n.language] || obj.fr;
  const [openIndex, setOpenIndex] = useState(null);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: "var(--lm-s1)" }}>
      <div className="max-w-3xl mx-auto">
        <FadeInUp>
          <div className="text-center mb-16 space-y-4">
            <span
              className="inline-block text-xs font-medium uppercase tracking-widest px-3 py-1 rounded-full"
              style={{ color: "#5e6ad2", backgroundColor: "rgba(94,106,210,0.1)", border: "1px solid rgba(94,106,210,0.2)" }}
            >
              FAQ
            </span>
            <h2
              className="font-semibold"
              style={{ color: "var(--lm-ink)", fontSize: "clamp(28px, 4vw, 40px)", letterSpacing: "-1px" }}
            >
              {t({ fr: "Questions Fréquentes", en: "Frequently Asked Questions", ar: "الأسئلة الشائعة" })}
            </h2>
            <p className="text-base" style={{ color: "var(--lm-ink-2)" }}>
              {t({ fr: "Tout ce que vous devez savoir sur Mawered", en: "Everything you need to know about Mawered", ar: "كل ما تحتاج لمعرفته حول Mawered" })}
            </p>
          </div>
        </FadeInUp>

        <FadeInUp delay={0.1}>
          <div className="space-y-2">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl overflow-hidden"
                style={{ backgroundColor: "var(--lm-s2)", border: "1px solid #23252a" }}
              >
                <button
                  className="w-full text-left px-5 py-4 flex items-center justify-between gap-4 transition-colors"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  style={{ color: "var(--lm-ink)" }}
                >
                  <span className="font-medium text-sm">{t(faq.question)}</span>
                  <ChevronDown
                    className="w-4 h-4 flex-shrink-0 transition-transform"
                    style={{
                      color: "var(--lm-ink-2)",
                      transform: openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </button>
                {openIndex === index && (
                  <div
                    className="px-5 pb-4 text-sm leading-relaxed"
                    style={{ color: "var(--lm-ink-2)", borderTop: "1px solid #23252a", paddingTop: "12px" }}
                  >
                    {t(faq.answer)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </FadeInUp>

        <FadeInUp delay={0.3}>
          <div
            className="mt-10 text-center p-8 rounded-xl"
            style={{ backgroundColor: "var(--lm-s2)", border: "1px solid #23252a" }}
          >
            <h3 className="font-medium mb-1 text-base" style={{ color: "var(--lm-ink)" }}>
              {t({ fr: "Vous avez d'autres questions ?", en: "Have more questions?", ar: "هل لديك المزيد من الأسئلة؟" })}
            </h3>
            <p className="text-sm mb-4" style={{ color: "var(--lm-ink-2)" }}>
              {t({ fr: "Notre équipe est là pour vous aider", en: "Our team is here to help you", ar: "فريقنا هنا لمساعدتك" })}
            </p>
            <button
              onClick={() => scrollToSection("contact")}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
              style={{ backgroundColor: "var(--lm-s3)", color: "var(--lm-ink)", border: "1px solid #23252a" }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--lm-border)")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--lm-s3)")}
            >
              <Mail className="w-4 h-4" style={{ color: "#5e6ad2" }} />
              {t({ fr: "Nous contacter", en: "Contact us", ar: "اتصل بنا" })}
            </button>
          </div>
        </FadeInUp>
      </div>
    </section>
  );
};

export default LandingFAQ;
